<template>
  <div>
    <div style="text-align: right;">
      <span
        style="float: left; margin-top: 5px;"
        class="ant-descriptions-title"
      >
        Thông tin chung
      </span>
    </div>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <a-descriptions :column="1">
        <a-descriptions-item label="Mã nhân viên">
          {{ employee.code }}
        </a-descriptions-item>
        <a-descriptions-item label="Tên nhân viên">
          {{ employee.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Giới tính">
          <span v-if="employee.gender === 'NONE'">Khác </span>
          <span v-else-if="employee.gender === 'MALE'">Nam </span>
          <span v-else-if="employee.gender === 'FEMALE'">Nữ</span>
        </a-descriptions-item>
        <a-descriptions-item label="Ngày sinh">
          {{ employee.birthday | formatDate }}
        </a-descriptions-item>
        <a-descriptions-item label="Phòng ban">
          <span
            v-if="
              employee.department && employee.department.status === 'DEACTIVE'
            "
          >
            <del> {{ employee.department.name }} </del>
          </span>
          <span
            v-else-if="
              employee.department && employee.department.status === 'ACTIVE'
            "
          >
            {{ employee.department.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Chức vụ">
          <span
            v-if="employee.position && employee.position.status === 'DEACTIVE'"
          >
            <del> {{ employee.position.name }} </del>
          </span>
          <span
            v-else-if="
              employee.position && employee.position.status === 'ACTIVE'
            "
          >
            {{ employee.position.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Kiêm nhiệm"> </a-descriptions-item>
        <!-- <a-descriptions-item label="Người tạo">
          {{ employee.author && employee.author.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ employee.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ employee.updatedAt | formatDateHour }}
        </a-descriptions-item> -->
      </a-descriptions>
    </a-skeleton>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    loadingItem: {
      type: Boolean,
      default: true,
    },
    employee: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>
